import {Injectable} from '@angular/core';

/**
 * Translations for campaign statuses.
 */
@Injectable()
export class CampaignStatusTranslationsService {
  public i18nSubscribedStatus: any = $localize`:@@general.status.subscribed:Granted`;
  public i18nUnsubscribedStatus: any = $localize`:@@general.status.unsubscribed:Opted out`;
  public i18nBouncedStatus: any = $localize`:@@general.status.bounced:Bounced`;
  public i18nSubscribedSelect: any = $localize`:@@general.status.permissionGrantedSubscribed:Permission Granted`;
  public i18nUnsubscribedSelect: any = $localize`:@@general.status.permissionDeniedUnsubscribed:Permission Denied`;
  public i18nBouncedSelect: any = $localize`:@@general.status.bouncedAvailable:Bounced`;
  constructor() { }
}
